(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
(() => {
  let gesture = null;
  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'touch' || !event.isPrimary) return;
    const image = event.target.closest('.tg-equipment .tg-gallery-image');
    gesture = image ? { image, x: event.clientX, y: event.clientY, id: event.pointerId } : null;
  }, { passive: true });
  document.addEventListener('pointercancel', () => { gesture = null; }, { passive: true });
  document.addEventListener('pointerup', (event) => {
    const start = gesture;
    gesture = null;
    if (!start || start.id !== event.pointerId) return;
    const dx = event.clientX - start.x;
    const dy = event.clientY - start.y;
    if (Math.abs(dx) < 50 || Math.abs(dy) > Math.abs(dx) / 2) return;
    const group = start.image.closest('[data-product-single-media-group]');
    const links = Array.from(group.querySelectorAll('[data-thumbnail-id]'));
    const index = links.findIndex(link => link.dataset.thumbnailId === start.image.dataset.mediaId);
    const next = links[index + (dx < 0 ? 1 : -1)];
    if (index >= 0 && next) next.click();
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();
})();
